import React from 'react';
import Form, {
    Actions,
    AddressValidator,
    Checkboxes,
    Conditional,
    EmailAddressValidator,
    Frequency,
    Money,
    ObjectFields,
    PhoneNumber,
    PhoneNumberValidator,
    Radio,
    RequiredValidator,
    TextField,
    ULID,
} from '../../../Components/Form';
import { GuestAddress } from '../../../Components/Form/Fields/Address';
import { usePredefined } from '../../../Data/Services';
import { useOnboarding, selectedServiceOptions } from '../OnboardingProvider';
import StepShell, { nextSubmit } from '../Components/StepShell';

// Quick-add customer + job, adapted from Pages/Customer/EditCustomer.jsx.
// The job's service picker reads from the wizard's step-1 selection (the
// account doesn't exist yet, so there's no /services API to ask).
const FirstCustomerStep = () => {
    const {draft, updateStepData, markSkipped, next, back, goTo} = useOnboarding();
    const {predefined} = usePredefined();

    const serviceOptions = selectedServiceOptions(draft.data.services, predefined);

    const skip = () => {
        markSkipped('customer');
        next();
    };

    const submit = (data) => {
        updateStepData('customer', {...data, skipped: false});
        next();
    };

    return <StepShell
        title="Add your first customer"
        intro="Add a customer and their regular job now, and your schedule starts working from day one."
    >
        <Form
            data={draft.data.customer}
            onChange={(data) => updateStepData('customer', data)}
            onSubmit={submit}
        >
            <TextField label="Name" name="name" validators={[RequiredValidator]} />
            <Radio label="Customer Type" name="type" layout="SmallCards" options={[
                {label: 'Individual', value: 'Individual'},
                {label: 'Business', value: 'Business'},
                {label: 'Unknown', value: 'Unknown'},
            ]} validators={[RequiredValidator]} />
            <Conditional condition={formData => formData.type === 'Business'}>
                <TextField label="Business name" name="businessName" type="text" validators={[]} />
            </Conditional>
            <TextField label="Email" name="email" type="email" validators={[EmailAddressValidator]} />
            <PhoneNumber label="Phone number" name="phoneNumber" validators={[PhoneNumberValidator]} />
            <GuestAddress label="Address" name="address" validators={[AddressValidator]} />

            <div className="mt-2">
                <ObjectFields name="job">
                    <Checkboxes
                        name="services"
                        label="Job services"
                        options={serviceOptions}
                        noItems="You haven't picked any services yet."
                    />
                    <button
                        type="button"
                        className="-mt-2 mb-3 text-xs text-muted hover:text-brand cursor-pointer"
                        onClick={() => goTo('services')}
                    >
                        Edit your services
                    </button>
                    <Conditional condition={formData => formData.services?.length > 0}>
                        <Frequency name="frequency" label="Frequency" />
                        <Money name="cost" label="Cost" />
                        <ULID name="jobId" />
                    </Conditional>
                </ObjectFields>
            </div>

            <ULID name="customerId" />

            <Actions
                submit={nextSubmit}
                cancel={{label: 'Back', onClick: back}}
                left={<button type="button" className="my-3 text-sm text-muted hover:text-brand cursor-pointer" onClick={skip}>
                    I'll do this later
                </button>}
            />
        </Form>
    </StepShell>;
};

export default FirstCustomerStep;
